import DeleteIcon from "@mui/icons-material/Delete";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import * as React from "react";
import { PurgeApi } from "../api/AdminApi";

export default function AdminPanelView() {
  const sendRequest = (endpoint) => {
    fetch(PurgeApi + endpoint, {
      method: "DELETE",
    });
  };

  return (
    <Stack direction="row" spacing={2}>
      <Button
        onClick={() => {
          sendRequest("traits");
        }}
        variant="outlined"
        startIcon={<DeleteIcon />}
      >
        Delete Traits
      </Button>
      <Button
        onClick={() => {
          sendRequest("trait-types");
        }}
        variant="outlined"
        startIcon={<DeleteIcon />}
      >
        Delete Trait Types
      </Button>
      <Button
        onClick={() => {
          sendRequest("languages");
        }}
        variant="outlined"
        startIcon={<DeleteIcon />}
      >
        Delete Languages
      </Button>
      <Button
        onClick={() => {
          sendRequest("vehicles");
        }}
        variant="outlined"
        startIcon={<DeleteIcon />}
      >
        Delete Vehicles
      </Button>

      <Button
        onClick={() => {
          sendRequest("insurance");
        }}
        variant="outlined"
        startIcon={<DeleteIcon />}
      >
        Delete Insurances
      </Button>

      <Button
        onClick={() => {
          sendRequest("all");
        }}
        variant="outlined"
        startIcon={<DeleteIcon />}
      >
        Delete All
      </Button>
    </Stack>
  );
}
